// Centralized config access for environment variables
// Use build-time CRA env vars first, then fall back to any runtime globals set on window.
const getWindow = () => (typeof window !== "undefined" ? window : {});

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  getWindow().__REACT_APP_API_BASE_URL ||
  "";

const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  getWindow().__REACT_APP_GOOGLE_MAPS_API_KEY ||
  "";

export { API_BASE_URL, GOOGLE_MAPS_API_KEY };

export default {
  API_BASE_URL,
  GOOGLE_MAPS_API_KEY,
};
